<template>
  <div style="width:100%;float:left;">
    <CCol sm="12">
      <CCard>
        <CCardBody style="text-align:center;">
          <label style="color:grey;">Add CSR(s) To View Their Orders</label>
          <div style="width:100%;float:left;text-align: center;margin-bottom: 10px;">
            <CButton size="sm" :color="viewAll ? 'info' : 'outline-info'" @click="viewAll = !viewAll, csrChanged()">View All</CButton>
          </div>
          <div style="width:100%;float:left;text-align: center;">
            <v-select v-if="csrs" @input="csrChanged()" style="width:100%;margin-left:auto;margin-right:auto;" v-model="csrs_selected" :options="csrs" multiple label="name"></v-select>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
    <div class="col-sm-3 col-md-2 float-left" v-if="data && !allOrdersLoading" v-for="val in statuses">
      <!-- <CWidgetDropdown :color="'gradient-' + val.color" :header="'' + data[val.header]" :text="'' + val.status">
        <template #footer>
          <CCardFooter class="card-footer px-3 py-2 mt-2">
            <CLink
              class="font-weight-bold font-xs btn-block"
              :class="'text-' + val.color"
              :color="val.color"
              @click="viewOrders(val.status)"
            >
              View Orders
              <CIcon name="cil-arrowRight" class="float-right" width="16"/>
            </CLink>
          </CCardFooter>
        </template>
      </CWidgetDropdown> -->
      <div class="card" :class="`bg-${val.color} text-white`">
        <div class="card-body pb-0 d-flex justify-content-between">
          <div style="width:100%;">
            <div style="width:100%;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;" class="text-value-lg">{{data[val.header]}}</div>
            <div style="width:100%;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{val.status}}</div>
          </div>
          <slot></slot>
        </div>
        <CCardFooter class="card-footer px-3 py-2 mt-2">
            <CLink
              class="font-weight-bold font-xs btn-block"
              :class="'text-' + val.color"
              :color="val.color"
              @click="viewOrders(val.status)"
            >
              View Orders
              <CIcon name="cil-arrowRight" class="float-right" width="16"/>
            </CLink>
          </CCardFooter>
      </div>
    </div>
    <small-loader v-if="allOrdersLoading"></small-loader>
    <div style="width:100%;float:left;" v-if="pdfs && !loading">
      <inner-pdf-table :currentStatus="currentStatus" @statusChanged="statusChanged" :items="pdfs"></inner-pdf-table>
    </div>
    <small-loader v-if="loading"></small-loader>
  </div>
</template>
<script>
import InnerPdfTable from './../components/inner_pdf_table'
var methods = {}

methods.statusChanged = function (item, index) {
  console.log(item)
  console.log(index)
  const postData = {
    form: item
  }
  axios.post(this.$apiAdress + '/api/orders/changeCsrStatus?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.pdfs.splice(index, 1)
    this.getAllOrders()
  })
}

methods.getAllOrders = function () {
  this.allOrdersLoading = true
  const postData = {
    csrs: this.csrs_selected,
    viewAll: this.viewAll
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/orders/getPdfOrdersCount?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log('ooo')
    console.log(response)
    this.data = response.data
    this.allOrdersLoading = false
  })
}

methods.viewOrders = function (status) {
  this.currentStatus = status
  window.localStorage.setItem('pdf_dash', status)
  window.localStorage.setItem('pdf_dash_view_all', this.viewAll)
  this.loading = true
  const postData = {
    status: status,
    csrs: this.csrs_selected,
    viewAll: this.viewAll
  }
  console.log('view orders')
  console.log(postData)
  axios.post(this.$apiAdress + '/api/orders/viewPdfOrders?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.pdfs = response.data
    this.loading = false
  })
}

methods.getCsrs = function () {
  axios.get(this.$apiAdress + '/api/getAllCsrs?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    this.csrs = response.data
    var that = this
    // this.csrs.forEach(function (val) {
    //   if (val.id === that.$store.state.user.id) {
    //     that.csr_selected = val
    //   }
    // })
  })
}

methods.csrChanged = function () {
  window.localStorage.setItem('pdf_dash_csr', JSON.stringify(this.csrs_selected))
  this.getAllOrders()
  this.viewOrders(this.currentStatus)
}

export default {
  // ===Component name
  name: "CsrPdfDashboard",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {
    InnerPdfTable
  },
  // ====component Data properties
  data(){
      return{
        data: null,
        pdfs: null,
        currentStatus: null,
        loading: false,
        csrs_selected: [],
        allOrdersLoading: false,
        csrs: null,
        viewAll: false,
        statuses: [
          {header: 'good_to_go', text: "Good To Go", color: 'success', status: 'Good To Go'},
          {header: 'sent_to_art', text: "Sent To Art", color: 'warning', status: 'Sent To Art'},
          {header: 'sent_to_we', text: "Sent To WE", color: 'secondary', status: 'Sent To WE'},
          {header: 'hold', text: "Hold/Sent For Approval", color: 'danger', status: 'Hold/Sent For Approval'},
          {header: 'events', text: "Events-Check Shipping", color: 'info', status: 'Events-Check Shipping'},
        ]
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    // this.getAllOrders()
    this.getCsrs()
    var s = window.localStorage.getItem('pdf_dash')
    var all = window.localStorage.getItem('pdf_dash_view_all')
    var csr = window.localStorage.getItem('pdf_dash_csr')
    if (all) {
      this.viewAll = all
    }
    if (csr) {
      this.csrs_selected = JSON.parse(csr)
      this.getAllOrders()
      if (s) {
        // this.currentStatus = s
        this.viewOrders(s)
      }
    } else if (s) {
      this.viewOrders(s)
      this.getAllOrders()
    }
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
